export default class RankResponse {
    ytd_label: string;
    entries: Array<data.rank.RankViewModel>;
}